<template>
  <div class="elements-side-menu">
      Elements
    
  </div>
</template>

<script>

export default {
  name: 'ElementsSideMenu'
}
</script>

<style scoped>

</style>